// extracted by mini-css-extract-plugin
export default {"average-component":"averages-component_average-component__i-CYB"};